// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@kubb/plugin-client/clients/axios";
import type { GetSubscriptionSubscriptionsGetQueryResponse } from "../models/subscriptionsController/GetSubscriptionSubscriptionsGet.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";

function getGetSubscriptionSubscriptionsGetUrl() {
  const res = { method: "GET", url: `/subscriptions/` as const };
  return res;
}

/**
 * @description Get current subscription with details for authenticated user.
 * @summary Get Subscription
 * {@link /subscriptions/}
 */
export async function getSubscriptionSubscriptionsGet(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetSubscriptionSubscriptionsGetQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: getGetSubscriptionSubscriptionsGetUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
